document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('qris-popup-overlay');
  const closeBtn = document.querySelector('.qris-popup-close');

  if (!popup || !closeBtn) return;

  const storageKey = 'qris_popup_closed_at';
  const sevenDays = 7 * 24 * 60 * 60 * 1000;
  const lastClosed = localStorage.getItem(storageKey);

  function showPopup() {
    popup.classList.add('active');
  }

  function closePopup() {
    popup.classList.remove('active');
    localStorage.setItem(storageKey, Date.now().toString());
  }

  if (!lastClosed || Date.now() - Number(lastClosed) > sevenDays) {
    setTimeout(showPopup, 8000);
  }

  closeBtn.addEventListener('click', closePopup);

  popup.addEventListener('click', function (event) {
    if (event.target === popup) {
      closePopup();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closePopup();
    }
  });
});